import { forwardRef, memo } from "react";
import PrintableBadgeCard from "./PrintableBadgeCard";
import { formattedDateTimeWithoutSec } from "../../lib/functions";
import { useTranslation } from "react-i18next";

interface BulkPrintableBadgesProps {
  appointments: any[];
  isPrintBadgeWithoutPicture: boolean;
}

const BulkPrintableBadges = forwardRef<
  HTMLDivElement,
  BulkPrintableBadgesProps
>(({ appointments, isPrintBadgeWithoutPicture }, ref) => {
  const { i18n } = useTranslation();

  return (
    <div ref={ref}>
      {appointments.map((appointment, index) => {
        const visitorPhoto = `data:image/png;base64,${appointment?.s_Photo}`;
        const visitorInfo = [
          {
            id: 1,
            titleEn: "Reference Number",
            titleAr: "الرقم المرجعي",
            value: appointment?.s_AppointmentCode,
          },
          {
            id: 2,
            titleEn: "Visitor Name",
            titleAr: "اسم الزائر",
            value: appointment?.s_VisitorName,
          },
          {
            id: 3,
            titleEn: "Organization Name",
            titleAr: "الجهة التابع لها",
            value: appointment?.s_Sponsor,
          },
          {
            id: 8,
            titleEn: "Building",
            titleAr: "مبنى",
            value:
              i18n.language === "en"
                ? appointment?.s_BuildingName_En
                : appointment?.s_BuildingName_Ar,
          },
          {
            id: 4,
            titleEn: "Department",
            titleAr: "قسم",
            value:
              i18n.language === "en"
                ? appointment?.s_DepartmentName_En
                : appointment?.s_DepartmentName_Ar,
          },
          {
            id: 5,
            titleEn: "Issue and Expiry Date",
            titleAr: "تاريخ الإصدار والانتهاء",
            value: `${formattedDateTimeWithoutSec(
              appointment?.dt_AppointmentStartTime
            )} - ${formattedDateTimeWithoutSec(
              appointment?.dt_AppointmentEndTime
            )}`,
            styles: "font-bold text-red-600 badge-dates",
          },
          {
            id: 6,
            titleEn: "Host Name",
            titleAr: "اسم المضيف",
            value: appointment?.s_HostName,
            styles: "badge-dates",
          },
          {
            id: 7,
            titleEn: "Host Number",
            titleAr: "رقم المضيف",
            value: appointment?.s_HostMobileNo,
          },
          {
            id: 8,
            titleEn: "Devices",
            titleAr: "الأجهزة",
            value:
              i18n.language === "en"
                ? appointment?.s_AllowedDevices_En
                : appointment?.s_AllowedDevices_Ar,
          },
        ];

        return (
          <div key={index} className="page-break-after">
            <PrintableBadgeCard
              visitorInfo={visitorInfo}
              visitorPhoto={!isPrintBadgeWithoutPicture ? visitorPhoto : ""}
              qrCode={appointment?.s_QRCodeValue}
            />
          </div>
        );
      })}
    </div>
  );
});

export default memo(BulkPrintableBadges);
